<script lang="ts">
    import CheckMark from '$lib/assets/check.png'
    import CloseArrow from '$lib/assets/close_arrow.svg'
    import CTA from './CTA.svelte'

    export let showPopUp : boolean
    export let handleOutsidePopUpClick
</script>

<div class="signup-pop-up" class:signup-pop-up-open={showPopUp}>
    <div class="signup-pop-up__card">
        <button class="signup__close" on:click={handleOutsidePopUpClick}>
            <img src={CloseArrow} />
        </button>
        <h3>Get started with OfferZen</h3>
        <ul class="signup__list">
            <li><img src={CheckMark} /> <span>Make <span class="bold">unlimited hires</span> and save up to 50% compared to traditional recruitment costs.</span></li>
            <li><img src={CheckMark} /> <span>Hire at a <span class="bold">predictable cost</span> with OfferZen’s custom annual plan.</span></li>
            <li><img src={CheckMark} /> <span>Access <span class="bold">200+ new job-seeking developers</span> every Monday.</span></li>
            <li><img src={CheckMark} /> <span>Guarantee your success with a free <span class="bold">dedicated hiring success manager</span></span></li>
        </ul>
        <div class="signup__cta">
            <CTA text="Get access to developers" url="https://www.offerzen.com/hire/get-started?marketplace_preview_lead=true" className="cta"  properties={{
                action: 'clicked get access',
                label: 'organic demand role pages',
                source_detail: 'candidate preview section',
                source: 'demand marketing page',
                category: 'marketing pages',
                name: 'Demand activity'
            }}/> 
            <CTA text="Book a demo" url="https://www.offerzen.com/hire/book-call?marketplace_preview_lead=true" theme="outlined-blue" className="cta" properties={{
                action: 'clicked book a demo',
                label: 'organic demand role pages',
                source_detail: 'candidate preview section',
                source: 'demand marketing page',
                category: 'marketing pages',
                name: 'Demand activty'
            }}/>
        </div>
        <p class="signup__login">Already have an account? <a href="https://www.offerzen.com/users/sign_in">Log in</a></p>
    </div>
</div>

<style lang="postcss">
    @import '../../styles/_mixins.css';
    .signup-pop-up {
        display: none;
        position: fixed;
        top:63px;
        z-index:800;
        width:100vw;
        background-color: rgba(19, 31, 74, 0.5);
        height:95%;
        align-items: center;
        justify-content: center;

        & .bold {
            font-weight:700;
        }

        & .signup-pop-up__card {
            position: relative;
            max-width: 528px;
            padding:43px 36px;
            border-radius: 5px;
            background-color:var(--color_white);

            & h3 {
                margin: 12px auto 24px;
                font-size: 24px;
                font-weight: 600;
                text-align: center;
            }

            & .signup__close {
                position: absolute;
                top: 24px;
                right: 24px;
                background-color: rgba(255, 255, 255, 0.7);
                padding: 8px;
                cursor: pointer;
                border: 1px solid rgba(136, 139, 142, 0.5);
                border-radius: 3px;
                line-height: 0;

                &:hover {
                    cursor: pointer;
                }
            }
        }

        & .signup__list {
            list-style-type: none;
            margin:0;
            padding:0;
            color:var(--color_offerzen_navy);

            & li {
                margin:0 0 24px;
                display: flex;
                gap:10px;
                line-height: 140%;
                & img { 
                    height:20px;
                    margin-top:1px;
                }
            }
        }

        & .signup__cta {
            display: flex;
            flex-direction: column;
            gap:16px;

            & :global(.cta) { 
                width: 100%;
                max-width:100%;
            }

            @mixin screen-md {
                gap:24px;
            }

            @mixin screen-sm {
                flex-direction:column;
                width:100%;
            }
        }

        & .signup__login {
            text-align: center;

            & a {
                color: var(--color_offerzen_cerulean_secondary);
                text-decoration: none;
            }
        }
    }

    .signup-pop-up-open {
        display: flex;
    }
</style>